import React from "react";
import { Navigate } from "react-router-dom";

//Dashboard
import Dashboard from "../Pages/Dashboard";

// Import Authentication pages
import ForgetPasswordPage from "../Pages/Authentication/ForgetPassword";
import Login from "../Pages/Authentication/Login";
import Logout from "../Pages/Authentication/Logout";
import Register from "../Pages/Authentication/Register";
// import UserProfile from "../Pages/Authentication/user-profile";
import ClientList from "../Pages/Client/clientList";
import RegisterClient from "../Pages/Client/registerClient";
import ViewAllguardLocation from "../Pages/GuardLocation/viewAllguardLocation";
import AllNotifications from "../Pages/Notification/allNotifications";
import CreateTicket from "../Pages/Ticket/createTicket";
import UpdateTicket from "../Pages/Ticket/updateTicket";
import ViewTicket from "../Pages/Ticket/viewTicket";
import RegisterUser from "../Pages/User/registerUser";
import KmlManager from "../Pages/KmlManager";
import CreateKml from "../Pages/KmlManager/createKml";
import KMLDataTable from "../Pages/Dashboard/kml";
import NotAuthorized from "../Pages/Authentication/NotAuthorized";
import ManageUser from "../Pages/User/manageUser";
import TrackLocation from "../Pages/GuardLocation/trackLocation";
import Reports from "../Pages/Reports";
import FilterComponent from "../Pages/Dashboard/test";
import ViewSelectedTicket from "../Pages/Ticket/viewselectedTicket";
import ViewPublickTicket from "../Pages/Ticket/PublicTicket";
import Analysis from "../Pages/Analysis/analysis";
import TicketHistory from "../Pages/Ticket/ticketHistory";
import UserHistory from "../Pages/Ticket/userHistory";
import AnalysisReport from "../Pages/Analysis/analysisReport";
import GuardList from "../Pages/GuardLocation/gaurdList";
import CheckIn from "../Pages/Checkin";
import UserCheckInReports from "../Pages/Checkin/checkinReport";

const authProtectedRoutes = [
  //dashboard
  { path: "/dashboard", component: <Dashboard /> },
  // Profile
  // { path: "/userprofile", component: <UserProfile /> },
  { path: "/create-ticket", component: <CreateTicket /> },
  { path: "/update-ticket", component: <UpdateTicket /> },
  { path: "/manage-ticket", component: <ViewTicket /> },

  { path: "/register", component: <Register /> },
  { path: "/guard-location", component: <ViewAllguardLocation /> },
  { path: "/track-location", component: <TrackLocation /> },
    { path: "/all-location", component: <GuardList /> },

  { path: "/reports", component: <Reports /> },
  { path: "/analysis", component: <Analysis /> },
  { path: "/detail-analysis", component: <AnalysisReport /> },

  {path: "/ticket-history", component: <TicketHistory />},
  {path: "/user-history", component: <UserHistory />},
  {path: "/check-in", component: <CheckIn />},
  {path:"/checkin-report", component:<UserCheckInReports/>},




  { path: "/register-user", component: <RegisterUser /> },
  { path: "/manage-user", component: <ManageUser /> },
  { path: "/manage-client", component: <ClientList /> },
  { path: "/manage-kml", component: <KmlManager /> },
  { path: "/create-kml", component: <CreateKml /> },
  { path: "/upload-json", component: <KMLDataTable /> },
  { path: "/not-authorized", component: <NotAuthorized /> },
  { path: "/register-client", component: <RegisterClient /> },
  { path: "/all-notifications", component: <AllNotifications /> },
  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  {
    path: "/",
    exact: true,
    component: <Navigate to="/dashboard" />,
  },
];

const publicRoutes = [
  // Authentication Page
  { path: "/logout", component: <Logout /> },
  { path: "/test", component: <FilterComponent /> },
  { path: "/login", component: <Login /> },
  { path: "/forgot-password", component: <ForgetPasswordPage /> },
  { path: "/view-ticket/:serialId/:caller", component: <ViewPublickTicket /> },
  
];

export { authProtectedRoutes, publicRoutes };
